import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { NovaViabilidade } from 'pages/NovaViabilidade'
import { ResultadoViabilidade } from 'pages/ResultadoViabilidade'
import { Viabilidade } from 'pages/Viabilidade'
import TelemetryProvider from './telemetry-provider'

const Routes = () => {
  return (
    <Router>
      <TelemetryProvider instrumentationKey={process.env.REACT_APP_APP_INSIGHTS_INSTRUMENTATION_KEY}>
        <Switch>
          <Route path="/" exact />
          <Route path="/terrenos/:idTerreno/viabilidades" component={Viabilidade} exact />
          <Route path="/terrenos/:idTerreno/viabilidades/nova-viabilidade" component={NovaViabilidade} exact />
          <Route path="/terrenos/:idTerreno/viabilidades/:idViabilidade" component={ResultadoViabilidade} exact />
        </Switch>
      </TelemetryProvider>
    </Router>
  )
}

export default Routes
